import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'
import {gallerySlider} from './module/gallery-slider'
import {mapInstitutions} from './module/map-institution'
import {historySlider} from './module/history-slider'
import {quotesSlider} from './module/quotes-slider'
import {colVideoMobileSlider} from './module/col-video-mobile-slider'
import {fakeSelectInput} from './module/fake-select-input'
import {quizJobjs} from './module/quizz-job'
import {filterJobs} from './module/filter-jobs'
import getYouTubeID from 'get-youtube-id'
import YouTubePlayer from 'youtube-player'
import $ from 'jquery-validation'

new factory.IAInit()
openMobileSubmenu()

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})


document.querySelectorAll('.swiper-container.is-fullwidth').forEach((el) => {
    new factory.IASwiper(el, {
        fullwidth: true,
        paginationElement: '.swiper-pagination',
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 4
            }
        }
    })
})

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
              },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
    /* if(!!document.querySelector('.checkbox-list')){
        document.querySelectorAll('.checkbox-list input').forEach(checkboxList => {
            console.log(checkboxList)
            $(checkboxList).rules("add",  'requireOne' );  
        })
    } */
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}
if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}

document.querySelectorAll('.ia-block-quicksearch').forEach((quicksearch)=>{

    let quicksearchToggle = quicksearch.querySelector('.ia-block-quicksearch-toggle')
    let quicksearchTarget = quicksearch.querySelector('.ia-block-quicksearch-content')

    quicksearchToggle.addEventListener('click', (e) => {
        if (quicksearchTarget === undefined || quicksearchTarget === null) {
            // check if toggler has a data-target or data-toggle attribute
            quicksearchTarget = quicksearchToggle.getAttribute('data-target') || quicksearchToggle.getAttribute('data-toggle');
            if (quicksearchTarget === null) {
                quicksearchTarget = e.target.nextElementSibling
            }
        }
    
        if (quicksearchTarget !== null) {
            //$(quicksearchTarget).slideToggle()
            quicksearchTarget.classList.toggle('active')
            quicksearch.classList.toggle('open')
            let classes = (quicksearchTarget.classList.contains("active"))?'fas fa-angle-right':'fas fa-search'
            setTimeout(() => {
                quicksearchTarget.querySelector('input').focus()
                quicksearchToggle.querySelector('i').setAttribute('class', classes)
            }, 50);
        }
    })
})

document.addEventListener("DOMContentLoaded",function(){
    if (!!document.querySelector('.swiper-container')) {
        document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
            if(el.classList.contains('ia-block-sector-header__featured-images')){
                const swiperInstance = new factory.IASwiper(el, {
                    // Overriding rules
                    autoplay: false,
                    spaceBetween: 36,
                    itemPerSlide: 3,
                    watchOverflow: true,
                    // Custom rules
                    scrollbar: {
                        el: el.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                        },
                        800: {
                            slidesPerView: 3,
                        }
                    }
                })
            }
            if(el.classList.contains('ia-block-donation-projects__item__list-images')){
                const swiperInstance = new factory.IASwiper(el, {
                    // Overriding rules
                    autoplay: false,
                    spaceBetween: 36,
                    itemPerSlide: Number(el.dataset.images),
                    watchOverflow: true,
                    // Custom rules
                    scrollbar: {
                        el: el.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.1,
                            spaceBetween: 20
                        },
                        821: {
                            slidesPerView: Number(el.dataset.images),
                        }
                    }
                })
            }
        })
    }
    gallerySlider()

    if (!!document.querySelector('.is-style-header-cover')) {
        if (!!document.querySelector('.ia-block-listing-categories')) {
            const listCategories = document.querySelector('.ia-block-listing-categories').cloneNode(true)
            listCategories.classList.add('is-mobile')
            document.querySelector('.is-style-header-cover').insertAdjacentElement('afterend', listCategories)
        }

        if (!!document.querySelector('.wp-block-button__link[href*="youtu"]')) {
            document.querySelectorAll('.wp-block-button__link[href*="youtu"]').forEach(link => {
                link.addEventListener('click', function(e){
                    e.preventDefault()
                    if (!!document.querySelector('#video-player')) {
                        document.querySelector('#video-player').remove()
                    }
                    const div = document.createElement('div')
                    const div2 = document.createElement('div')
                    div.setAttribute('id', 'video-player')
                    div2.setAttribute('class', 'video-player__container')
                    div2.append(div)
                    link.closest('.is-style-header-cover').append(div2)
                    
                    const idVideo = getYouTubeID(e.target.href)
                    const player = YouTubePlayer('video-player', {
                        videoId: idVideo,
                        playerVars: {
                            rel:0,
                            showinfo:0,
                            controls:1,
                            fs:0,
                            hl: document.querySelector('html').lang,
                            iv_load_policy: 3,
                            modestbranding: 1,
                        }
                    })
                    player.playVideo()
                    setTimeout(() => {
                        
                        div2.classList.add('active')
                    }, 10);
                    

                    div2.addEventListener('click', function(e){
                        e.stopImmediatePropagation()
                        div2.classList.remove('active')
                        setTimeout(() => {
                            div2.remove()
                        }, 500);
                    })
                })
            })
        }
    }
        if(!!document.querySelector('[class*="is-style-change-icon-"]')) {
            document.querySelectorAll('[class*="is-style-change-icon-"]').forEach(elem => {
                elem.style.position = 'relative'
                
                const id = getYouTubeID(elem.querySelector('iframe').src)
                const youtubeThumb = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`
                const div = document.createElement('div')
                div.setAttribute('class', 'youtube-thumb-replace')
                if (!!elem.querySelector('figcaption')) {
                    div.style.height = `calc(100% - ${elem.querySelector('figcaption').clientHeight}px`
                }
                div.style.backgroundImage = `url(${youtubeThumb})`
                elem.append(div)

                div.addEventListener('click', function(e){
                    setTimeout(() => {
                        div.remove()
                    }, 450);
                    elem.querySelector('iframe').src += '&autoplay=1'
                })
            })
        }
    

    if (!!document.querySelector('.ia-block-map-instritutions')) {
        mapInstitutions()
    }
    if (!!document.querySelector('.ia-block-listing-history')) {
        document.querySelectorAll('.ia-block-listing-history').forEach(div => {
            historySlider(div)
        })
    }
    if (!!document.querySelector('.ia-block-listing-quotes')) {
        document.querySelectorAll('.ia-block-listing-quotes').forEach(div => {
            quotesSlider(div)
        })
    }
    if (!!document.querySelector('.ia-block-video-column-list')) {
        document.querySelectorAll('.ia-block-video-column-list').forEach(div => {
            colVideoMobileSlider(div)
        })
    }
    if (!!document.querySelector('.fake-select-input-content')) {
        document.querySelectorAll('.fake-select-input-content').forEach(input => {
            fakeSelectInput(input)
        })
    }
    if (!!document.querySelector('.ia-block-quizz')) {
        document.querySelectorAll('.ia-block-quizz').forEach(quizz => {
            quizJobjs(quizz)
        })
    }
    if (!!document.querySelector('.ia-block-listing-jobs__filter')) {
        document.querySelectorAll('.ia-block-listing-jobs__filter .fake-select-input').forEach(input => {
            input.addEventListener('fakeinput', filterJobs)
        })
        document.querySelector('#main-content').style.overflow = 'inherit'
    }

    if (!!document.querySelector('.js-expand-container')) {
        document.querySelectorAll('.js-expand-container').forEach(block => {
            let button = block.querySelector('.js-expand-button')
            let content = block.querySelector('.js-expand-content')
            let charLimit = parseInt(content.dataset.charlimit)
            let truncatedContent = ''
            let expandContent = ''

            if (button) {
                if (content.innerHTML.length <= charLimit) {
                    truncatedContent = content.innerHTML
                    expandContent = ''
                    //button.closest('.wp-block-buttons').style.display = 'none'
                } else {
                    truncatedContent = content.innerHTML.slice(0, charLimit)
                    expandContent = content.innerHTML.slice(charLimit).replace(button.outerHTML, '')
                    //button.closest('.wp-block-buttons').style.display = 'block'
                    content.innerHTML = truncatedContent + '&nbsp;<span class="ellipsis">[...]&nbsp;' + button.outerHTML + '</span><span class="hidden-text">' + expandContent + '</span>'

                    console.log(content.querySelector('.ellipsis'))
                }
    
                content.querySelector('.js-expand-button').addEventListener('click', e => {
                    let ellipsis = block.querySelector('.ellipsis')
                    let hiddenText = block.querySelector('.hidden-text')
    
                    console.log({ellipsis, hiddenText})
    
                    ellipsis.style.display = 'none'
                    hiddenText.style.display = 'inline'
                })
            }
        })
    }

    if (!!document.querySelector('.wp-block-gallery.is-style-newsletter-loadmore')) {
        document.querySelectorAll('.wp-block-gallery.is-style-newsletter-loadmore').forEach(gallery => {
            let lines = 3
            let perLines = gallery.classList.contains('columns-3') ? 3 : (gallery.classList.contains('columns-4') ? 4 : 2);

            let itemsToShow = lines * perLines
            let hiddenItems = []
            gallery.querySelectorAll('figure.wp-block-image').forEach((img, idx) => {
                if (idx >= itemsToShow) {
                    img.style.display = 'none'
                    hiddenItems.push(img)
                }
            })

            if (hiddenItems.length > 0) {
                let loadMore = document.createElement('div')
                loadMore.classList.add('wp-block-buttons', 'aligncenter')

                let loadMoreButton = document.createElement('div')
                loadMoreButton.classList.add('wp-block-button', 'is-style-outline')

                let loadMoreButtonLink = document.createElement('button')
                loadMoreButtonLink.classList.add('wp-block-button__link', 'js-gallery-load-more')
                loadMoreButtonLink.textContent = 'Toutes les photos'

                loadMoreButton.appendChild(loadMoreButtonLink)
                loadMore.appendChild(loadMoreButton)
                gallery.appendChild(loadMore)

                loadMoreButtonLink.addEventListener('click', (e) => {
                    let toHide = []
                    hiddenItems.forEach((img, idx) => {
                        if (idx < itemsToShow) {
                            img.style.display = 'block'
                        } else {
                            toHide.push(img)
                        }
                    })

                    hiddenItems =  toHide

                    if (hiddenItems.length <= 0) {
                        loadMore.style.display = 'none'
                    }
                })
            }
        })
    }
})


const waitingForInstaFeed = new Promise((resolve, reject) => {
    let i = 0
    const interval = setInterval(() => {
        if (!!document.querySelector('.sbi_item')) {
            resolve()
            clearInterval(interval)
        }
        i++
        if (i > 10) {
            reject()
            clearInterval(interval)
        }
    }, 1000);
    
    
})

waitingForInstaFeed
.then(()=> {
    customiseInstaFeedContent()
})
.catch(()=> {
    console.log('no feed')
})

function customiseInstaFeedContent() {
    document.querySelectorAll('.sbi_item').forEach(item => {
        const div = document.createElement('div')
        div.setAttribute('class', 'custom-description-card')
        if(!!document.querySelector('.sbi_feedtheme_header_text h3')) {
            div.innerText = document.querySelector('.sbi_feedtheme_header_text h3').innerText
        } else {
            div.innerText = 'elisabeth.luxembourg'
        }
        item.insertAdjacentElement('afterbegin', div)

        item.classList.add('swiper-slide')
    })

    const scrollbarDiv = document.createElement('div')
    scrollbarDiv.setAttribute('class', 'swiper-scrollbar')
    document.querySelector('#sbi_images').insertAdjacentElement('afterend', scrollbarDiv)


    document.querySelector('#sbi_images').classList.add('swiper-wrapper')
    colVideoMobileSlider(document.querySelector('#sb_instagram'))


    const cloneBtnFollow = document.querySelector('.sbi_follow_btn').cloneNode(true)
    document.querySelector('.sbi_follow_btn').style.display = 'none'
    document.querySelector('.sbi_header_text').insertAdjacentElement('beforeend', cloneBtnFollow)


    if(!!document.querySelector('.sbi_bio')) {
            let desc = document.querySelector('.sbi_bio');
            const newDesc = document.querySelector('.sbi_bio').innerHTML.split('$');
            desc.innerHTML = '';
        
            newDesc.forEach(line => {
                const span = document.createElement('span');
                span.innerHTML = line;
                desc.appendChild(span);
            });
        
    }


}